import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import './Tile.scss';
import ExpandIcon from 'assets/icons/icon-expand.svg';
import PlayIcon from 'assets/icons/play.svg';
import classNames from 'classnames';
import AtelierModel3DViewer from 'components/VirtualAtelier/Uploads/AtelierModelUploads/AtelierModel3DViewer';

export interface ITile {
  image?: string;
  aspectRatio?: string;
  objectFit?: string;
  video?: string;
  model?: string;
  caption?: React.ReactElement | string;
  alt?: string;
  imgClassNames?: string[];
  renderingThumbnail?: boolean;
  item?: any;
  type?: string;
  original?: any;
  setOriginal?: (arg: any) => void;
  vaGalleryView?: boolean;
}

const Tile: React.FC<ITile> = props => {
  const {
    alt,
    image,
    video,
    model,
    caption,
    aspectRatio,
    objectFit,
    imgClassNames,
    renderingThumbnail,
    type,
    original,
    setOriginal,
    vaGalleryView,
  } = props;

  const vidRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const [icon, setIcon] = useState('');
  const [loadIcons, setLoadIcons] = useState(true);

  useEffect(() => {
    if (loadIcons) {
      loadIcon(alt?.split('.')[alt?.split('.').length - 1]);
    }
    return () => setLoadIcons(false);
  }, [alt, loadIcons]);

  const loadIcon = async (iconName: string) => {
    try {
      const importedIcon = await import(
        `assets/icons/${iconName.toLocaleUpperCase()}.svg`
      );
      setIcon(importedIcon.default);
    } catch (error) {
      const importedIcon = await import(`assets/icons/Icon-folder.svg`);
      setIcon(importedIcon.default);
    }
  };

  return (
    <>
      <div
        className='tile'
        style={{ height: !renderingThumbnail && !vaGalleryView ? '455px' : '' }}
      >
        <div
          className={`ratio${aspectRatio} ratio-wrap`}
          style={{ height: !renderingThumbnail && !vaGalleryView ? '455px' : '' }}
        >
          {image && (
            <div>
              <img
                className={classNames('ratio-img', {
                  [`ratio-img__${objectFit}`]: objectFit,
                  [`${imgClassNames?.join(' ')}`]: imgClassNames,
                })}
                style={{ height: !renderingThumbnail && !vaGalleryView ? '455px' : '' }}
                src={image}
                alt={alt}
              />
            </div>
          )}

          {video && (
            <>
              <ReactPlayer
                playing={playing}
                ref={vidRef}
                className={classNames(
                  'tile__player',
                  !renderingThumbnail && 'tile__player-height'
                )}
                url={video}
                controls={!renderingThumbnail}
                width='100%'
                height='100%'
                muted
              />
              <div
                className={playing || renderingThumbnail ? 'hide' : 'tile__playIcon'}
                onClick={() => setPlaying(true)}
              >
                <img src={PlayIcon} alt='Play' />
              </div>
            </>
          )}

          {model && (
            <div className='tile__player'>
              <AtelierModel3DViewer url={model} name={caption} />
            </div>
          )}

          {!video && !image && !model && (
            <div
              className='mm--h3 ratio-flex-center'
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: !renderingThumbnail && 'flex-start',
              }}
            >
              <div className='product-upload__drag-area'>
                <img
                  style={{
                    height: '64px',
                    width: '64px',
                  }}
                  src={icon}
                  alt={alt}
                />
                {!renderingThumbnail && (
                  <div className='product-upload__txt'>
                    <p className='product-upload__instructions'>
                      {"This file can't be previewed"}
                    </p>
                    <p className='txt-gray-light'> {alt}</p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {!renderingThumbnail && (
        <div className='tile__caption'>
          {caption}
          {type === 'image' && (
            <img
              src={ExpandIcon}
              className={'tile__expand'}
              onClick={() => setOriginal(original)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Tile;
